module.exports = __webpack_public_path__ + "static/img/videobg.27bb16d8.png";